import React, { useState } from 'react';
import Modal from 'react-modal';

const BurgerModal = ({ onTrigger }) => {
    const [burgerIsOpen, setBurgerIsOpen] = useState(false);

    const openBurgerModal = () => setBurgerIsOpen(true);
    const closeBurgerModal = () => setBurgerIsOpen(false);

    // Передаём функцию для внешнего управления
    React.useEffect(() => {
        if (onTrigger) {
            onTrigger(openBurgerModal);
        }
    }, [onTrigger]);

    const burgerModalContent = (
        <div className='burger-modal-content-container'>
            <button className='closeBurger' onClick={closeBurgerModal}></button>
            <div className='burger-list'>
                <a href="/" className='burger-text'>ГЛАВНАЯ</a>
                <a href="https://forum.medieval-rp.net/" className='burger-text' target='_blank'>ФОРУМ</a>
                <a href="https://medieval-rp.net/ucp/shop" className='burger-text'>МАГАЗИН</a>
            </div>
            <div className='burger-social-icons-container'>
                <a href="https://vk.com/medievalrpnet" target='_blank'><button className='vk-icon'></button></a>
                <a href="https://t.me/medieval_rp" target='_blank'><button className='telegram-icon'></button></a>
            </div>
        </div>
    );

    return (
        <Modal
            isOpen={burgerIsOpen}
            onRequestClose={closeBurgerModal}
            style={{
                overlay: {
                    position: 'fixed',
                    zIndex: 1020,
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'none',
                    display: 'flex',
                    borderRadius: "none",
                },
                content: {
                    width: '50vw',
                    height: '100vh',
                    background: 'rgba(0, 0, 0, 1)',
                    overflowY: 'auto',
                    position: 'relative',
                    border: "none",
                    
                    color: '#FFF',
                    margin: "0 0",
                    padding: "0 0",
                    transition: "0.2s",
                    inset: "0",
                    borderRadius: "none",
                }
            }} 
            ariaHideApp={false}
        >
            {burgerModalContent}
        </Modal>
    );
};

export default BurgerModal;
